var _rect, _path, _rect2, _path2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 81,
    viewBox: "0 0 200 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.418945,
    width: 200,
    height: 20,
    rx: 10,
    fill: "#DF8981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.419C15.8417 10.419 17.3334 8.92729 17.3334 7.08562C17.3334 5.24396 15.8417 3.75229 14 3.75229C12.1584 3.75229 10.6667 5.24396 10.6667 7.08562C10.6667 8.92729 12.1584 10.419 14 10.419ZM14 12.0856C11.775 12.0856 7.33337 13.2023 7.33337 15.419V17.0856H20.6667V15.419C20.6667 13.2023 16.225 12.0856 14 12.0856Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30.4189,
    width: 144,
    height: 20,
    rx: 10,
    fill: "#7871C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 40.419C15.8417 40.419 17.3334 38.9273 17.3334 37.0856C17.3334 35.244 15.8417 33.7523 14 33.7523C12.1584 33.7523 10.6667 35.244 10.6667 37.0856C10.6667 38.9273 12.1584 40.419 14 40.419ZM14 42.0856C11.775 42.0856 7.33337 43.2023 7.33337 45.419V47.0856H20.6667V45.419C20.6667 43.2023 16.225 42.0856 14 42.0856Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 60.4189,
    width: 90,
    height: 20,
    rx: 10,
    fill: "#1B2473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70.419C15.8417 70.419 17.3334 68.9273 17.3334 67.0856C17.3334 65.244 15.8417 63.7523 14 63.7523C12.1584 63.7523 10.6667 65.244 10.6667 67.0856C10.6667 68.9273 12.1584 70.419 14 70.419ZM14 72.0856C11.775 72.0856 7.33337 73.2023 7.33337 75.419V77.0856H20.6667V75.419C20.6667 73.2023 16.225 72.0856 14 72.0856Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spend.e2f33736b93251feaf74da95ec0d936a.svg";